// import { useRouter } from 'next/router'
import { BrowserRouter as Router, Link, NavLink, useLocation } from "react-router-dom";
// import { NavHashLink } from 'react-router-hash-link';
import { DisplayRoute } from "../routes";
// import Image from 'next/image'
import { atom, useAtom } from 'jotai'
import _ from "lodash"
import { useState, useEffect, useRef, forwardRef } from 'react'

// import { isSmallAtom } from "../atoms";
import {isSmallAtom,titleAtom,isShowingMobileMenuAtom} from '../atoms/atom.config.js'

import useDeviceSize from '../components/useDeviceSize';
import { mobileWidth, mobileHeight } from '../constants';

import {MobileMenu} from '../components/MobileMenu'

// assets
import logoImage from '../assets/images/default_thumb.jpg' //button_mobile_menu.svg
// import logoImage2 from './default_thumb.jpg'

// assets
// import menuImage from '../assets/icons/button_mobile_menu.svg'
// <Image src={menuImage} alt="Menu" width={16} height={16} /> 
// <MobileMenu stroke='black' fill='red' strokeWidth={1.5} width='38px' height='38px'/>

// import React from "react";
// // import { ReactComponent as MobileMenu } from "../assets/icons/button_mobile_menu.svg";

// import dynamic from 'next/dynamic'
// const MobileMenu = dynamic(() => import('../assets/icons/button_mobile_menu.svg'), {
//   ssr: false,
// })

// svgr: https://react-svgr.com/docs/next/
// import MobileMenu from '../assets/icons/button_mobile_menu.svg'
// import MobileMenu from '../assets/icons/icon_object.svg'
import menuIcon from '../assets/icons/icon_menu.svg'
import logoIcon from '../assets/icons/logo_desktop.svg'
import logoIconHover from '../assets/icons/logo_desktop_h.svg'
import logoIconMobile from '../assets/icons/logo_mobile.svg'
//logo_RBA3.svg'
// import logoIcon from '../assets/icons/icon_security_large.svg' //logo_RBA.svg'
import helpIcon from "../assets/icons/icon_help.svg"

//const GalleryItemDetail = (props) => {
export default function Header(props) {
  //console.log(props);
  // const router = useRouter()
  const names = ['Ada Lovelace', 'Grace Hopper', 'Margaret Hamilton'];

  const [isSmall, setIsSmall] = useAtom(isSmallAtom);
  const [title, setTitle] = useAtom(titleAtom);
  //const [isShowingMobileMenu, setIsShowingMobileMenu] = useAtom(isShowingMobileMenuAtom);
  const [isShowingMobileMenu, setIsShowingMobileMenu] = useState(false);
  const {pathname} = useLocation(); // https://stackoverflow.com/questions/46244279/how-to-close-navigation-menu-on-route-change
  const mobileMenuRef = useRef(null); 
  const logoRef = useRef(null); 

  const [isLogoHover, setIsLogoHover] = useState(false);

  //const [showMenu, setShowMenu] = useState(true);
  //const [showMenu, setShowShareModal] = useAtom(showShareModalAtom);

  const [deviceWidth, deviceHeight] = useDeviceSize();


  const onMenuClosed = () => {
    setIsShowingMobileMenu(false)
    
  };
  const onMenuFade = () => {
    console.log("onMenuFade", mobileMenuRef)
    if(mobileMenuRef) {
      if(mobileMenuRef.current) {
        //console.log("CALL FADEOUT")
        mobileMenuRef.current.fadeOutMod()
      }
      
    } else {
      onMenuClosed()
    }
  }
  const forceReload = () => {
    console.log("FORCE RELOAD if on same/intro page!", pathname)
    window.location.reload();
  };
  //const toggleAudio = () => {
  const onMenuOpen = () => {
    console.log("menu open");
    setIsShowingMobileMenu(true)

  };

  useEffect(() => {
    console.log("HEADER w/h changed:", deviceWidth,deviceHeight)
    const small = (deviceWidth < mobileWidth) || (deviceHeight < mobileHeight)
    setIsSmall( small )
    //console.log("props", props)
    console.log("mobile menu:", isShowingMobileMenu, pathname, small)
    
  }, [deviceWidth,deviceHeight,isSmall]);

  useEffect(() => {
    //setIsShowingMobileMenu(false) // default is to hide the menu on navigation page change
    onMenuFade()

    // state change whenever the URL changes - can use this to reset tabindex/focus
    // FIXME: this is breaking the scroller when we refresh from halfway down the page
    setTimeout(() => {
      console.log("mobile menu refocus", logoRef)
      if(logoRef) {
        if(logoRef.current) {
          console.log("!!! FOCUS RESET !!!");
          logoRef.current.focus();
        }
      }
    },500);
    
    

  }, [pathname]);

  const highlighted = `underline decoration-2 underline-offset-8 opacity-100 transition duration-200 underline decoration-2 underline-offset-8 decoration-white/[1.0]`;
  const notHighlighted = 'opacity-100 transition duration-500 underline decoration-2 underline-offset-8 decoration-white/[0.0] hover:decoration-white/[1.0]'

  return (
    <div className="block fixed w-full top-0 pt-6 h-navbarHt z-40 pointer-events-none" id="nav" >
      {/* <a href="#yo" className="absolute mt-[-100px]" tabIndex="-1" ref={logoRef}>YO</a> */}
      {
        <div className='flex '>
          <div className="flex justify-start grow items-center">
            {/* {isSmall ?
              <div className="mx-5 w-[70px] flex-none cursor-pointer pointer-events-auto">
                <a tabIndex="1" href="https://museum.rba.gov.au/" target="_blank" >{!isShowingMobileMenu && <img src={logoIconMobile} className="" alt="Reserve Bank of Australia Museum Website"  /> }</a>
              </div>
              :
              <div className="mx-8 w-[368px] flex-none cursor-pointer pointer-events-auto transition-transform hover:scale-105 duration-500" onMouseEnter={()=> setIsLogoHover(true)} onMouseLeave={()=> setIsLogoHover(false)}>
                 <a tabIndex="1" href="https://museum.rba.gov.au/" target="_blank" >{!isShowingMobileMenu && <img src={logoIcon} className="" alt="Reserve Bank of Australia Museum Website"  /> }</a>
              </div>
            } */}
            <div className="mx-8 w-[200px] xxsm:w-[250px] xsm:w-[368px] flex-none cursor-pointer pointer-events-auto transition-transform hover:scale-105 duration-500" onMouseEnter={()=> setIsLogoHover(true)} onMouseLeave={()=> setIsLogoHover(false)}>
                 <a tabIndex="1" href="https://museum.rba.gov.au/" target="_blank" >{!isShowingMobileMenu && <img src={logoIcon} className="w-[368px]" alt="Reserve Bank of Australia Museum Website"  /> }</a>
              </div>
           
          </div>
          {!isSmall ?
          <div className="flex justify-end items-center font-bold mx-8 gap-x-7 cursor-pointer pointer-events-auto">
            {/* <NavLink to="/" className={({ isActive }) => isActive ? highlighted : notHighlighted}>Introduction</NavLink> */}
            <NavLink id="introlink" tabIndex="3" to="/" end onClick={ pathname == "/" ? forceReload : null} className={({ isActive }) => isActive ? highlighted : notHighlighted}>Introduction</NavLink>
            {/* <Link to="/about">About</Link> */}
            <NavLink tabIndex="4" to="/five" onClick={ pathname == "/five" ? forceReload : null} className={({ isActive }) => isActive ? highlighted : notHighlighted}>$5</NavLink>
            <NavLink tabIndex="5" to="/ten" onClick={ pathname == "/ten" ? forceReload : null} className={({ isActive }) => isActive ? highlighted : notHighlighted}>$10</NavLink>
            <NavLink tabIndex="6" to="/twenty" onClick={ pathname == "/twenty" ? forceReload : null} className={({ isActive }) => isActive ? highlighted : notHighlighted}>$20</NavLink>
            <NavLink tabIndex="7" to="/fifty" onClick={ pathname == "/fifty" ? forceReload : null} className={({ isActive }) => isActive ? highlighted : notHighlighted}>$50</NavLink>
            <NavLink tabIndex="8" to="/hundred" onClick={ pathname == "/hundred" ? forceReload : null} className={({ isActive }) => isActive ? highlighted : notHighlighted}>$100</NavLink>
            {/* <NavLink to={process.env.PUBLIC_URL+"/five"} onClick={ pathname == "/five" ? forceReload : null} className={({ isActive }) => isActive ? highlighted : notHighlighted}>{process.env.PUBLIC_URL}$5</NavLink> */}
            
            <button tabIndex="9" className={notHighlighted} onClick={props.onHelpClicked} ><img src={helpIcon} className="w-[24px] h-[24px] transition-transform hover:scale-110 " alt="Help"  /></button>
            </div>
            : <div className="w-[80px]">
              {!isShowingMobileMenu &&
                <button tabIndex="3" className="flex flex-none justify-start mx-5 w-[80px] cursor-pointer pointer-events-auto" onClick={onMenuOpen} >
                  {/* props.onMenuClicked */}
                  {/* <MobileMenu /> */}
                <img src={menuIcon} alt="menu" width={32} height={32} />
                {/* <MobileMenu stroke='black' strokeWidth={1.5} width='52px' height='52px'/> */}
                {/* <Image src="/icon_object.svg" height={30} width={30} /> */}
              </button>}
            </div>
          
         }

          {isSmall &&
          <div id="topGradient" className="absolute block h-28 w-full z-[-100] top-0 left-0">
                <div className="h-full w-full bg-gradient-to-b from-black/60 to-transparent "></div>
          </div>}          
        </div >
       
      }

      {/* mobile menu overlay */}
      {isShowingMobileMenu && 
        <MobileMenu ref={mobileMenuRef} onMenuClose={onMenuClosed} onHelpClicked={props.onHelpClicked}/>
      }
    </div>
  )
}


// const Link = forwardRef((props,ref) => {
// // const Link = ({ children, href }) => {
//   const router = useRouter()
//   return (
//     <a
//       ref={ref}
//       //innerRef={ref}
//       href="#"
//       onClick={(e) => {
//         e.preventDefault()
//         // typically you want to use `next/link` for this usecase
//         // but this example shows how you can also access the router
//         // and use it manually
//         router.push(props.href)
//       }}
//     >
//       {props.children}
//       {/* <style jsx>{`
//         a {
//           margin-right: 10px;
//         }
//       `}</style> */}
//     </a>
//   )
// })
